import { Component, OnInit, Input, ComponentFactoryResolver, ViewContainerRef, ViewChild, AfterViewInit, Inject, Optional } from '@angular/core';
import { GfTitleService } from '../../../../services/core.title.service';
import * as _ from 'lodash';
import { UserService } from '../../../../services/core.user.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { StateService } from '@uirouter/angular';
import { RegisterViewComponent } from '../register/register.component';
import { ConfirmViewComponent } from '../confirm/confirm.component';

@Component({
  selector: 'user-registration-request',
  template: require('./user.registration.request.component.html')
})
export class UserRegistrationRequestComponent implements OnInit, AfterViewInit {
  @Input() registrationMode: any;
  @Input() msg: any;
  @Input() siteConfig: any;
  @Input() requested: any;
  @Input() confirmed: any;

  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef, static: false }) dynamicComponentContainer!: ViewContainerRef;

  email: string = '';
  captcha: string = '';
  captchaRefresh: number = new Date().getTime();
  requireCaptcha: number = 0;
  sending: boolean = false;

  constructor(
    private userService: UserService,
    private titleService: GfTitleService,
    private stateService: StateService,
    private translateService: GfTranslateService,
    private componentFactoryResolver: ComponentFactoryResolver,
    @Inject('requested') @Optional() private requestedResolve: any,
    @Inject('confirmed') @Optional() private confirmedResolve: any
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.translateService.translate('User Registration Request'));
    this.requireCaptcha = Number(_.get(this.siteConfig, 'requireUserCaptcha', 0));
    this.email = decodeURIComponent(_.get(this.stateService.params, 'email', ''));
    this.msg = '';

    // Get resolve data from injected values
    this.requested = this.requestedResolve;
    this.confirmed = this.confirmedResolve;
  }

  ngAfterViewInit(): void {
    this.loadDynamicComponent();
  }

  private loadDynamicComponent(): void {
    if (!this.dynamicComponentContainer) {
      return;
    }

    let componentToLoad;

    if (this.confirmed) {
      componentToLoad = RegisterViewComponent;
    } else if (this.requested) {
      componentToLoad = ConfirmViewComponent;
    } else {
      return;
    }

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentToLoad);
    this.dynamicComponentContainer.clear();
    const componentRef = this.dynamicComponentContainer.createComponent(componentFactory);

    if (componentRef.instance) {
      Object.assign(componentRef.instance, {
        registrationMode: this.registrationMode,
        msg: this.msg,
        siteConfig: this.siteConfig,
        email: this.email
      });
    }
  }

  private validateForm(): boolean {
    return !_.isEmpty(_.get(this, 'email', ''));
  }

  sendRequest(ev: Event): void {
    ev.preventDefault();
    ev.stopPropagation();

    this.sending = true;
    const params = { email: this.email };

    if (!this.validateForm()) {
      this.msg = this.translateService.translate('Email is missing or invalid.');
      this.sending = false;
      return;
    }

    // Validate captcha if required
    if (this.requireCaptcha && (!this.captcha || this.captcha.trim() === '')) {
      this.msg = this.translateService.translate('Please complete the captcha verification.');
      this.sending = false;
      return;
    }

    this.msg = '';
    this.userService.submitEmail(this.email, 0, this.captcha || '')
      .then(() => {
        // Update state to show confirmation component
        this.requested = true;
        this.confirmed = false;
        this.sending = false;
        this.loadDynamicComponent();
      })
      .catch((err: any) => {
        this.sending = false;
        if (_.get(err, 'data.type', '') === 'user-registration-request-exists') {
          // Email already requested, show confirmation screen
          this.requested = true;
          this.confirmed = false;
          this.loadDynamicComponent();
        } else {
          this.msg = this.userService.getMsg();
        }
      });
  }
}
